import { useState } from 'react';
import { PageContainer, Card, Table, Button, Badge, Modal, Input, Dropdown } from '@aimsos/ui';
import { useDisclosure } from '@aimsos/hooks';
import { MoreVertical, Edit, Key, Trash2, UserPlus, Search, Mail } from 'lucide-react';

const USERS = [
  { id: 1, name: 'Alice Johnson', email: 'alice@company.com', role: 'Admin', status: 'Active', lastLogin: '2024-10-12' },
  { id: 2, name: 'Bob Smith', email: 'bob@company.com', role: 'Editor', status: 'Active', lastLogin: '2024-10-11' },
  { id: 3, name: 'Carol White', email: 'carol@company.com', role: 'Viewer', status: 'Pending', lastLogin: 'Never' },
  { id: 4, name: 'Dave Brown', email: 'dave@company.com', role: 'Editor', status: 'Active', lastLogin: '2024-10-10' },
  { id: 5, name: 'Eve Davis', email: 'eve@company.com', role: 'Viewer', status: 'Suspended', lastLogin: '2024-09-01' },
];

const statusVariant = { Active: 'success', Pending: 'warning', Suspended: 'danger' };

const COLUMNS = [
  { key: 'name', label: 'Name', sortable: true },
  { key: 'email', label: 'Email', sortable: true },
  { key: 'role', label: 'Role', sortable: true },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    render: (val) => <Badge variant={statusVariant[val]}>{val}</Badge>,
  },
  { key: 'lastLogin', label: 'Last Login', sortable: true },
  {
    key: 'actions',
    label: '',
    render: (_val, _row) => (
      <Dropdown
        align="right"
        trigger={
          <button className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-700 dark:hover:text-gray-300">
            <MoreVertical size={16} />
          </button>
        }
      >
        <Dropdown.Item icon={Edit}>Edit User</Dropdown.Item>
        <Dropdown.Item icon={Key}>Reset Password</Dropdown.Item>
        <Dropdown.Separator />
        <Dropdown.Item icon={Trash2} variant="danger">Remove User</Dropdown.Item>
      </Dropdown>
    ),
  },
];

const UsersList = () => {
  const { isOpen, open, close } = useDisclosure();
  const [search, setSearch] = useState('');

  const filtered = USERS.filter(
    (u) =>
      u.name.toLowerCase().includes(search.toLowerCase()) ||
      u.email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <PageContainer
      title="Users"
      actions={<Button leftIcon={UserPlus} onClick={open}>Invite User</Button>}
    >
      <Card>
        <Card.Header
          title="All Users"
          description={`${filtered.length} users`}
          action={
            <Input
              placeholder="Search users…"
              leftIcon={Search}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-56"
            />
          }
        />
        <Card.Body className="p-0">
          <Table columns={COLUMNS} data={filtered} />
        </Card.Body>
      </Card>

      <Modal isOpen={isOpen} onClose={close} title="Invite User">
        <div className="flex flex-col gap-4">
          <Input label="Email Address" type="email" placeholder="user@company.com" leftIcon={Mail} />
          <div>
            <label className="mb-1.5 block text-sm font-medium text-content-secondary">
              Role
            </label>
            <select className="w-full rounded-md border border-edge-strong bg-surface px-3 py-2 text-sm text-content focus:outline-none focus:ring-2 focus:ring-brand-500">
              <option>Viewer</option>
              <option>Editor</option>
              <option>Admin</option>
            </select>
          </div>
        </div>
        <Modal.Footer>
          <Modal.Button variant="secondary" onClick={close}>
            Cancel
          </Modal.Button>
          <Modal.Button leftIcon={Mail} onClick={close}>
            Send Invitation
          </Modal.Button>
        </Modal.Footer>
      </Modal>
    </PageContainer>
  );
};

export default UsersList;
